export default "__VITE_ASSET__CUbwnBst__"